import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppRoutingPaths } from './app-routing.enums';
import { BusinessAccountRoutes } from './business-account/business-account.routes';

const routes: Routes = [
  {
    path: AppRoutingPaths.Empty,
    loadComponent: () => import('./sign-up/pages/sign-up/sign-up.component').then((c) => c.SignUpComponent)
  },
  {
    path: AppRoutingPaths.Onboarding,
    children: [
      {
        path: AppRoutingPaths.Empty,
        redirectTo: AppRoutingPaths.Business,
        pathMatch: AppRoutingPaths.Full
      },
      {
        path: AppRoutingPaths.Business,
        loadComponent: () =>
          import('./core/router-outlets/business-router-outlet.component').then((c) => c.BusinessRouterOutletComponent),
        children: BusinessAccountRoutes.ROUTES
      }
    ]
  },
  {
    path: AppRoutingPaths.DocumentUpload,
    redirectTo: AppRoutingPaths.DocumentUploadRedirect,
    pathMatch: AppRoutingPaths.Full
  },
  {
    path: AppRoutingPaths.Contact,
    loadComponent: () => import('./contact-page/contact-page.component').then((c) => c.ContactPageComponent)
  },
  {
    path: AppRoutingPaths.NotFound,
    loadComponent: () =>
      import('./error-pages/not-found-page/not-found-page.component').then((c) => c.NotFoundPageComponent)
  },
  {
    path: AppRoutingPaths.WildCard,
    redirectTo: AppRoutingPaths.NotFound,
    pathMatch: AppRoutingPaths.Full
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
